import { render, staticRenderFns } from "./RemoteFeatureFlags.vue?vue&type=template&id=1a7dfc81"
import script from "./RemoteFeatureFlags.vue?vue&type=script&lang=ts"
export * from "./RemoteFeatureFlags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports